import { arredondar } from '../util/money';

export default class CalculadoraInss {
  constructor(faixasInss = [], tetoInss = []) {
    this.faixasInss = faixasInss.map((faixa, index) => ({ ...faixa, index }));
    // @TODO: Poderia criar um objeto para cada faixa e já calcular a dedução,
    // facilitando o get nos calculos
    this.tetoInss = tetoInss;
  }

  calcularDescontoInss(salario) {
    if (this.faixasInss.length === 0) {
      return 0;
    }

    const teto = this.getTetoMaxDesconto();
    const { calculo: aliquota } = this.getFaixaDoSalario(salario);
    const deducao = this.getParcelaDedutora(salario);
    const desconto = arredondar(salario * aliquota - deducao);

    return desconto > teto ? teto : desconto;
  }

  getParcelaDedutora(salario) {
    const faixaSalario = this.getFaixaDoSalario(salario);
    if (faixaSalario.subtracao) {
      return faixaSalario.subtracao;
    }

    const dedutores = this.getDedutores();
    return dedutores[faixaSalario.index];
  }

  getFaixaDoSalario(salario) {
    let valorFaixaAnterior = 0;
    let faixaInss = null;
    this.faixasInss.forEach((faixa) => {
      const valorFaixaAtual = faixa.valor || 0;
      if (salario >= valorFaixaAnterior && salario <= valorFaixaAtual) {
        faixaInss = faixa;
      }
      valorFaixaAnterior = valorFaixaAtual;
    });

    return faixaInss;
  }

  getDedutores() {
    let deducaoAcumulada = 0;

    return this.faixasInss.map((faixaAtual, index) => {
      const faixaAnterior = this.faixasInss[index - 1];

      if (faixaAnterior) {
        const diferencaPercentual = faixaAtual.calculo - faixaAnterior.calculo;
        deducaoAcumulada += faixaAnterior.valor * diferencaPercentual;
      }

      return arredondar(deducaoAcumulada);
    });
  }

  getTetoMaxDesconto() {
    const dedutorUltimaFaixa = this.getDedutorUltimaFaixa();
    const tetoInss = this.getTetoInss();
    const aliquotaUltimaFaixa = this.getAliquotaUltimaFaixa();

    return arredondar(tetoInss * aliquotaUltimaFaixa - dedutorUltimaFaixa);
  }

  getTetoInss() {
    return this.tetoInss[0].valor;
  }

  getDedutorUltimaFaixa() {
    const dedutores = this.getDedutores();
    return dedutores[dedutores.length - 1];
  }

  getAliquotaUltimaFaixa() {
    const ultimaFaixa = this.faixasInss[this.faixasInss.length - 1];
    return ultimaFaixa.calculo;
  }
}
